import { motion } from 'framer-motion';
import { PropsWithChildren } from 'react';

export const SlideUpContainer = ({ children }: PropsWithChildren) => {
  return (
    <motion.div
      initial={{ y: 350 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.4 }}
    >
      {children}
    </motion.div>
  );
};

export const SlideUpContainerWithDelay = ({ children }: PropsWithChildren) => {
  return (
    <motion.div
      initial={{ y: 500, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{
        duration: 0.4,
        delay: 0.2,
      }}
    >
      {children}
    </motion.div>
  );
};

export const SwipeUpContainer = ({ children }: PropsWithChildren) => {
  return (
    <motion.div
      initial={{ height: 'auto' }}
      animate={{ height: 'auto' }}
      exit={{ height: 0, marginBottom: 0 }}
      transition={{ duration: 0.4 }}
      className="overflow-hidden desktop:mb-10"
    >
      {children}
    </motion.div>
  );
};
